<!-- Estrutura sem menu e sidenav -->
<router-outlet></router-outlet> 
